import React, { useEffect, useRef, useState } from 'react';
import './ButtonImportSql.scss';

function ButtonImportSql({ handleSqlClick, handleDbmlClick, handlePlaygroundClick }) {
    const [isOpen, setOpen] = useState(false);
    const ref = useRef(null);

    useEffect(() => {
        const handleOutside = (e) => {
            if (ref.current && !ref.current.contains(e.target)) setOpen(false);
        };
        document.addEventListener('mousedown', handleOutside);
        return () => document.removeEventListener('mousedown', handleOutside);
    }, []);

    const handleImportSql = () => {
        handleSqlClick();
        setOpen(false);
    };

    const handleImportDbml = () => {
        handleDbmlClick();
        setOpen(false);
    };

    const handleImportPlayground = () => {
        // handlePlaygroundClick();
        setOpen(false);
    };

    return (
        <div ref={ref} className="btn-import-sql_wrap">
            <button
                type="button"
                className={`dash-main-header-button secondary ${isOpen ? 'hovered' : ''}`}
                onClick={() => setOpen((p) => !p)}
            >
                <div className='left-part'>Import SQL</div>
                <div className='right-part'>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M6 9L12 15L18 9"></path></svg>
                </div>
            </button>

            {isOpen && (
                <ul className="btn-import-sql_menu">
                    <li className='btn-import-sql_menu-item'>
                        <button
                            type="button"
                            className="btn-import-sql_menu-item-btn"
                            onClick={(e) => { handleImportSql(e); }}
                        >
                            Import SQL
                        </button>
                    </li>
                    <li className='btn-import-sql_menu-item'>
                        <button
                            type="button"
                            className="btn-import-sql_menu-item-btn"
                            onClick={(e) => { handleImportDbml(e); }}
                        >
                            Import DBML
                        </button>
                    </li>
                    <li className='btn-import-sql_menu-item'>
                        <button
                            type="button"
                            className="btn-import-sql_menu-item-btn"
                            onClick={(e) => { handleImportPlayground(e); }}
                        >
                            Import Playground
                        </button>
                    </li>
                </ul>
            )}
        </div>
    );
}


export default ButtonImportSql;
